import R from 'ramda';
import React from 'react';
import pt from 'prop-types';
import styled from 'styled-components';
import {connect} from "react-redux";
import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';

import ru from './icons/ru.png';
import en from './icons/en.png';
import fr from './icons/fr.png';

import {setLanguage} from '../actions/users'

const FLAGS = {ru, en, fr};


const DropdownElement = styled.div`
    margin: 18px 10px !important;
`;


class LanguageSelectorComponent extends React.Component {
    static propTypes = {
        currentLanguage: pt.string.isRequired,
        languages: pt.arrayOf(pt.shape()).isRequired,
    };

    renderMenuItem = item => (
        <Menu.Item key={item.code}>
            <p><img src={FLAGS[item.code]} width={17} height={17} alt={item.name}/> {item.name}</p>
        </Menu.Item>
    );

    onMenuItemSelect = (item) => {
        this.props.setLanguage({
            'language': item.key,
            'next': 'teacher/students/',
        })
    }

    getPopupContainer = () => document.getElementById('dropdown-popup-container');

    render() {
        const {languages, currentLanguage} = this.props;
        const menu = <Menu onSelect={this.onMenuItemSelect}>{R.map(this.renderMenuItem, languages)}</Menu>;
        return (
            <DropdownElement>
                <Dropdown overlay={menu} trigger={['click']} getPopupContainer={this.getPopupContainer}>
                    <a className="ant-dropdown-link" href="#">
                        <img src={FLAGS[currentLanguage]} width={24} height={24} alt={"меню"}/>
                    </a>
                </Dropdown>
            </DropdownElement>
        );
    }
}

const LanguageSelector = connect(
    null,
    dispatch => ({
        setLanguage: data => dispatch(setLanguage(data)),
    })
)(LanguageSelectorComponent);

export default LanguageSelector;



// WEBPACK FOOTER //
// ./src/incab/common/LanguageSelector/component.jsx